module.exports = __webpack_public_path__ + "media/images/angle_down-38f0907945de9a415831faeb57184aa6.png";